import { createSlice } from '@reduxjs/toolkit';
import { PfDueState } from './pfDueTypes';
import {
  createPfDue,
  fetchAllPfDues,
  updatePfDueIsProcessed
} from './pfDueActions';

const initialState: PfDueState = {
  records: [],
  loadingStates: {
    create: false,
    fetchAll: false,
    updateIsProcessed: false
  },
  errors: {}
};

const pfDueSlice = createSlice({
  name: 'pfDue',
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      // Create
      .addCase(createPfDue.pending, (state) => {
        state.loadingStates.create = true;
        state.errors.create = undefined;
      })
      .addCase(createPfDue.fulfilled, (state, action) => {
        state.loadingStates.create = false;
        state.records.push(action.payload.data);
      })
      .addCase(createPfDue.rejected, (state, action) => {
        state.loadingStates.create = false;
        state.errors.create = action.payload as string;
      })

      // Fetch All
      .addCase(fetchAllPfDues.pending, (state) => {
        state.loadingStates.fetchAll = true;
        state.errors.fetchAll = undefined;
      })
      .addCase(fetchAllPfDues.fulfilled, (state, action) => {
        state.loadingStates.fetchAll = false;
        state.records = action.payload.data;
      })
      .addCase(fetchAllPfDues.rejected, (state, action) => {
        state.loadingStates.fetchAll = false;
        state.errors.fetchAll = action.payload as string;
      })

      // Update isProcessed
      .addCase(updatePfDueIsProcessed.pending, (state) => {
        state.loadingStates.updateIsProcessed = true;
        state.errors.updateIsProcessed = undefined;
      })
      .addCase(updatePfDueIsProcessed.fulfilled, (state, action) => {
        state.loadingStates.updateIsProcessed = false;
        const index = state.records.findIndex((item) => item.pfDueId === action.payload.id);
        if (index !== -1) {
          state.records[index].isProcessed = action.payload.isProcessed;
        }
      })
      .addCase(updatePfDueIsProcessed.rejected, (state, action) => {
        state.loadingStates.updateIsProcessed = false;
        state.errors.updateIsProcessed = action.payload as string;
      });
  }
});

export default pfDueSlice.reducer;